module.exports = __webpack_public_path__ + "media/components/country-flag/static/yt-62f92df35447d41693395d191c9339be.svg";